import { BE, ES, FI, GB, JP } from "country-flag-icons/react/3x2";

export const languages = [
  {
    code: "en",
    name: "English",
    Flag: GB,
    dayjsCode: "en",
    dateFormats: {
      short: "M/D",
    },
  },
  {
    code: "fi",
    name: "Suomi",
    Flag: FI,
    dayjsCode: "fi",
    dateFormats: {
      short: "D.M.",
    },
  },
  {
    code: "nl-BE",
    name: "Vlaams (Nederlands)",
    Flag: BE,
    dayjsCode: "nl-be",
    dateFormats: {
      short: "D/M",
    },
  },
  {
    code: "es",
    name: "Español",
    Flag: ES,
    dayjsCode: "es",
    dateFormats: {
      short: "D/M",
    },
  },
  {
    code: "ja-JP",
    name: "日本語",
    Flag: JP,
    dayjsCode: "ja",
    dateFormats: {
      short: "M/D",
    },
  },
] as const;

export type Language = (typeof languages)[number];
export type LanguageCode = (typeof languages)[number]["code"];
